/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, codec: NonNullable<unknown>, layout: NonNullable<unknown> }} Audio_Embed_Export_Stream_AudioInputs */

const en_audio_embed_export_stream_audio = /** @type {(inputs: Audio_Embed_Export_Stream_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio ${i?.index}: ${i?.codec}${i?.layout}`)
};

const fr_audio_embed_export_stream_audio = /** @type {(inputs: Audio_Embed_Export_Stream_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio ${i?.index} : ${i?.codec}${i?.layout}`)
};

const de_audio_embed_export_stream_audio = /** @type {(inputs: Audio_Embed_Export_Stream_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio ${i?.index}: ${i?.codec}${i?.layout}`)
};

const it_audio_embed_export_stream_audio = /** @type {(inputs: Audio_Embed_Export_Stream_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio ${i?.index}: ${i?.codec}${i?.layout}`)
};

const ru_audio_embed_export_stream_audio = /** @type {(inputs: Audio_Embed_Export_Stream_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Аудио ${i?.index}: ${i?.codec}${i?.layout}`)
};

const es_audio_embed_export_stream_audio = /** @type {(inputs: Audio_Embed_Export_Stream_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio ${i?.index}: ${i?.codec}${i?.layout}`)
};

const zh_cn2_audio_embed_export_stream_audio = /** @type {(inputs: Audio_Embed_Export_Stream_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音频 ${i?.index}：${i?.codec}${i?.layout}`)
};

const ja_audio_embed_export_stream_audio = /** @type {(inputs: Audio_Embed_Export_Stream_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オーディオ ${i?.index}: ${i?.codec}${i?.layout}`)
};

const hi_audio_embed_export_stream_audio = /** @type {(inputs: Audio_Embed_Export_Stream_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑडियो ${i?.index}: ${i?.codec}${i?.layout}`)
};

const pt_pt2_audio_embed_export_stream_audio = /** @type {(inputs: Audio_Embed_Export_Stream_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Áudio ${i?.index}: ${i?.codec}${i?.layout}`)
};

/**
* | output |
* | --- |
* | "Audio {index}: {codec}{layout}" |
*
* @param {Audio_Embed_Export_Stream_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_stream_audio = /** @type {((inputs: Audio_Embed_Export_Stream_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Stream_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_stream_audio(inputs)
	if (locale === "de") return de_audio_embed_export_stream_audio(inputs)
	if (locale === "it") return it_audio_embed_export_stream_audio(inputs)
	if (locale === "ru") return ru_audio_embed_export_stream_audio(inputs)
	if (locale === "es") return es_audio_embed_export_stream_audio(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_stream_audio(inputs)
	if (locale === "ja") return ja_audio_embed_export_stream_audio(inputs)
	if (locale === "hi") return hi_audio_embed_export_stream_audio(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_stream_audio(inputs)
	return en_audio_embed_export_stream_audio(inputs)
});